import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ResponseObject } from "src/app/Services/auth.service";
import { SocialPostService } from 'src/app/Services/social-post.service';
import { ArtistProductsService } from 'src/app/Services/artistproducts.service';
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { NotificationTypes } from "src/app/app.enums";
import { FacebookService } from "src/app/Services/facebook.service";
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-connect-with-facebook',
    templateUrl: './connect-with-facebook.component.html',
    providers: [ArtistProductsService],
    standalone: false
})

export class ConnectWithFacebook implements OnInit{
  constructor(
    private activatedRoute:ActivatedRoute,
    private ngxSpinnerService:NgxSpinnerService,
    private SocialPostService:SocialPostService,
    private router: Router,
    private notificationsService: NotificationsService,
    private facebookService: FacebookService,
    private transloco: TranslocoService){

  }
  ngOnInit(): void {
    
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params['code'] && params['state']) {
          this.onFacebookCallBack(params['code'],params['state'])
        }
      });
   
  }

  public onFacebookCallBack(code: string,state: string){
    this.ngxSpinnerService.show();
    this.facebookService.onFacebookAccountsCallBack(code, state).subscribe((FacebookApiResponce: ResponseObject) => {
      console.log(FacebookApiResponce);
      if (FacebookApiResponce.Success) {
        this.notificationsService.showNotification(this.transloco.translate('connectWithFacebook.successTitle'), FacebookApiResponce.ResponseMessage, NotificationTypes.Success);
        //this.router.navigate([this.artistId , 'artworks' ,this.selectedProductId])
        this.router.navigate(['/facebook-accounts'])
      }else{
        this.ngxSpinnerService.hide();
        this.router.navigate(['/facebook-accounts'])
        this.notificationsService.showNotification(this.transloco.translate('connectWithFacebook.errorTitle'), FacebookApiResponce.ResponseMessage, NotificationTypes.Error);
      }
      this.ngxSpinnerService.hide();
    }, error => { console.log(error); this.ngxSpinnerService.hide(); });
  }

}